export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-11.12041dc9.jpg";